import { IPagination } from '../../../types/pagination'
import { calcRemainingPercentage } from '../../../utils/calculateRemainingPercentage'
import { BudgetCostsActions } from '../actions/budgetCostsActions'
import * as constants from '../actions/constants'
import { IProjectLabel } from '../types/project'
import { IProjectBudgetCost, IProjectBudgetCostChart } from './../types/costs'
import { IProjectPhase } from './../types/project'

export const initialBudgetCosts: IProjectBudgetCost[] = [
  {
    id: '',
    position: '',
    supplier: '',
    quantity: 0,
    unit_price: 0,
    total_cost: 0,
    phases: [] as IProjectPhase[],
    labels: [] as IProjectLabel[],
    project_cost_category_id: '',
    thereof_paid: 0,
    position_status: 'open',
    payments: []
  }
]

const initialBudgetCostsPagination: IPagination<IProjectBudgetCost[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: initialBudgetCosts,
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export  const initalBudgetCostChart: IProjectBudgetCostChart = {categories: [], costs: []}

export const budgetCosts = (state: IProjectBudgetCost[] = initialBudgetCosts, action: BudgetCostsActions): IProjectBudgetCost[] => {
  switch(action.type) {
    case constants.GET_COSTS_SUCCESS:
      return action.costs.sort((a, b) => { return +a.id - +b.id})

    case constants.GET_COSTS_OUTSTANDING_SUCCESS:
      return action.costs.sort((a,b) => calcRemainingPercentage(+b.thereof_paid, +b.total_cost) - calcRemainingPercentage(+a.thereof_paid, +a.total_cost))
    case constants.CREATE_COST_SUCCESS:
      return [...state, action.cost].sort((a, b) => { return +a.id - +b.id})

    case constants.DELETE_COST_SUCCESS:
      return state.filter(a => a.id !== action.cost.id)

    case constants.UPDATE_COST_SUCCESS:
      return state.map(a => {
        if (+a.id === +action.cost.id) {
          return action.cost
        }
        return a
      })

    default:
      return state
  }
}

export const budgetCostsCleanData = (state: IProjectBudgetCost[] = initialBudgetCosts, action: BudgetCostsActions): IProjectBudgetCost[] => {
  switch(action.type) {
    case constants.GET_COSTS_SUCCESS:
      return action.costs.sort((a, b) => { return +a.id - +b.id})

    case constants.CREATE_COST_SUCCESS:
      return [...state, action.cost].sort((a, b) => { return +a.id - +b.id})

    case constants.DELETE_COST_SUCCESS:
      return state.filter(a => a.id !== action.cost.id)

    case constants.UPDATE_COST_SUCCESS:
      return state.map(a => {
        if (+a.id === +action.cost.id) {
          return action.cost
        }
        return a
      })

    default:
      return state
  }
}

export const budgetCostsChart = (state: IProjectBudgetCostChart = initalBudgetCostChart, action: BudgetCostsActions): IProjectBudgetCostChart => {
  switch(action.type) {
    case constants.GET_COSTS_CHART_SUCCESS:
      return action.costs

    default:
      return state
  }
}

export const budgetCost = (state: IProjectBudgetCost = initialBudgetCosts[0], action: BudgetCostsActions): IProjectBudgetCost => {
  switch(action.type) {
    case constants.GET_COST_SUCCESS:
    case constants.UPDATE_COST_SUCCESS:
    case constants.CREATE_COST_SUCCESS:
      return action.cost

    case constants.DELETE_COST_SUCCESS:
      return initialBudgetCosts[0]

    default:
      return state
  }
}
export const paginatedBudgetCosts = (state: IPagination<IProjectBudgetCost[]> = initialBudgetCostsPagination, action: BudgetCostsActions): IPagination<IProjectBudgetCost[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_COSTS_OUTSTANDING_SUCCESS:
      return action.costs

    default:
      return state
  }
}

export const paginatedBudgetCostsActivePage = (state = 1, action: BudgetCostsActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_COSTS_OUTSTANDING_ACTIVE_PAGE:
      return action.page

    default:
      return state
  }
}
